import { Fragment } from 'react';
import { TransitionChild } from '@headlessui/react';
import { ModalStyles } from './_modalStyles';

// Modal backdrop ************************************
export function ModalBackdrop() {
  return (
    <TransitionChild
      as={Fragment}
      enter="ease-out duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className={ModalStyles.backdrop} />
    </TransitionChild>
  );
}
